import { resolveClient } from './supabase';
import type { SupabaseClient } from '@supabase/supabase-js';

export interface AuditLog {
  id: string;
  tenant_id: string;
  user_id: string | null;
  action: 'INSERT' | 'UPDATE' | 'DELETE';
  resource_type: string;
  resource_id: string | null;
  metadata: Record<string, any>;
  created_at: string;
  user?: {
    full_name: string | null;
    email: string;
  } | null;
}

export async function getAuditLogs(limit: number = 50, client?: SupabaseClient): Promise<AuditLog[]> {
  const supabase = resolveClient(client);

  const { data, error } = await supabase.from('audit_logs').select('*, user:users(full_name, email)').order('created_at', { ascending: false }).limit(limit);

  if (error) throw error;
  return (data || []) as AuditLog[];
}

export async function getAuditLogsByResource(resourceType: string, resourceId: string, client?: SupabaseClient): Promise<AuditLog[]> {
  const supabase = resolveClient(client);

  const { data, error } = await supabase.from('audit_logs').select('*').eq('resource_type', resourceType).eq('resource_id', resourceId).order('created_at', { ascending: false });

  if (error) throw error;
  return (data || []) as AuditLog[];
}

export async function getAuditLogsByAction(action: 'INSERT' | 'UPDATE' | 'DELETE', limit: number = 50, client?: SupabaseClient): Promise<AuditLog[]> {
  const supabase = resolveClient(client);

  const { data, error } = await supabase.from('audit_logs').select('*').eq('action', action).order('created_at', { ascending: false }).limit(limit);

  if (error) throw error;
  return (data || []) as AuditLog[];
}
